import { render, staticRenderFns } from "./editLog.vue?vue&type=template&id=4048ba0d&scoped=true"
import script from "./editLog.vue?vue&type=script&lang=js"
export * from "./editLog.vue?vue&type=script&lang=js"
import style0 from "./editLog.vue?vue&type=style&index=0&id=4048ba0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048ba0d",
  null
  
)

export default component.exports